import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

interface ComingSoonProps {
  title?: string;
}

export default function ComingSoon({ title }: ComingSoonProps): React.ReactElement {
  const navigate = useNavigate();
  return (
    <Result
      status="info"
      title={title ?? 'En développement'}
      subTitle="Cette fonctionnalité sera disponible dans une prochaine phase du projet."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Retour à l'accueil
        </Button>
      }
    />
  );
}
